import React, { useState } from "react";
import "./ButtonDropDown.scss";
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import {
  IDropdownButton,
  IDropdownButtonList,
} from "../../../interfaces/Index";

const DropdownButton: React.FunctionComponent<IDropdownButton> = (
  props: IDropdownButton
) => {
  const [dropdownOpen, setOpen] = useState(false);

  const toggle = () => setOpen(!dropdownOpen);

  const onHover = (event: any) => {
    toggle();
  };
  const onHoverLeave = (event: any) => {
    toggle();
  };

  const dropDownItems = () => {
    return (
      props.dropdownItem &&
      props.dropdownItem.map((item: IDropdownButtonList, i: number) => (
        <section key={i}>
          <DropdownItem
            className="btn-1"
            id={item.key || i.toString()}
            onClick={(e) => item.clickHandler(e)}
          >
            {item.buttonName}
          </DropdownItem>
          <DropdownItem divider />
        </section>
      ))
    );
  };

  return (
    <ButtonDropdown
      onMouseLeave={onHoverLeave}
      onMouseEnter={onHover}
      isOpen={dropdownOpen}
      toggle={toggle}
      className={props.classNames}
    >
      <DropdownToggle caret>{props.dropDownButtonText}</DropdownToggle>
      <DropdownMenu>{dropDownItems()}</DropdownMenu>
    </ButtonDropdown>
  );
};

export default DropdownButton;
